// ============================================
// ŞİRKET PANELİ - MOBİL ALT TAB BAR
// ============================================

import { Link, useRouterState } from '@tanstack/react-router';
import { LayoutDashboard, Briefcase, FileText, Building2, Menu } from 'lucide-react';
import { cn } from '@/utils';
import { useTranslation } from '@crew-at-sea/i18n';

interface CompanyMobileTabBarProps {
  onMoreClick: () => void;
}

export function CompanyMobileTabBar({ onMoreClick }: CompanyMobileTabBarProps) {
  const { t } = useTranslation('panel');
  const router = useRouterState();
  const currentPath = router.location.pathname;

  const tabs = [
    { name: t('sidebar.jobs'), href: '/jobs', icon: Briefcase },
    { name: t('sidebar.applications'), href: '/applications', icon: FileText },
    { name: t('sidebar.companyProfile', { defaultValue: 'Profil' }), href: '/profile', icon: Building2 },
  ];

  const isActive = (href: string) => {
    if (href === '/') return currentPath === '/';
    return currentPath.startsWith(href);
  };

  const isMoreActive = ['/candidates', '/settings', '/help', '/subscription']
    .some(p => currentPath.startsWith(p));

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 md:hidden safe-area-bottom">
      <div className="flex items-center justify-around h-16">
        {tabs.map((tab) => (
          <Link
            key={tab.href}
            to={tab.href}
            className={cn(
              'flex flex-col items-center justify-center flex-1 h-full gap-0.5 transition-colors',
              isActive(tab.href) ? 'text-maritime-600' : 'text-gray-400'
            )}
          >
            <tab.icon className="w-5 h-5" />
            <span className="text-[10px] font-medium leading-tight">{tab.name}</span>
          </Link>
        ))}
        <button
          onClick={onMoreClick}
          className={cn(
            'flex flex-col items-center justify-center flex-1 h-full gap-0.5 transition-colors',
            isMoreActive ? 'text-maritime-600' : 'text-gray-400'
          )}
        >
          <Menu className="w-5 h-5" />
          <span className="text-[10px] font-medium leading-tight">{t('sidebar.more', { defaultValue: 'Daha Fazla' })}</span>
        </button>
      </div>
    </nav>
  );
}
